<template>
  <div class="single-plant">
    <div class="single-plant__scroll-container">
      <div class="single-plant__container" v-if="content">
        <div class="single-plant__wrapper">
          <div ref="plantText">
            <h2 class="single-plant__subtitle">Aujourd'hui, la plante qu'il vous faut est&nbsp;:</h2>
            <h1 class="single-plant__title">{{ content.title }}</h1>
            <p class="single-plant__description">{{ content.desc }}</p>
          </div>

          <div class="single-plant__sharing">
            <p class="sharing__text">Partagez votre plante prodigieuse&nbsp;:</p>
            <div class="sharing__btns">
              <ui-button :shareInfos="shareInfos" type="facebook"></ui-button>
              <ui-button :shareInfos="shareInfos" type="twitter"></ui-button>
            </div>
          </div>

          <ui-button-to-home :goToFilters="true"></ui-button-to-home>
        </div>

        <div class="single-plant__canvas-container" ref="canvas"></div>
      </div>

        <div class="single-plant__container single-plant__container--error" v-if="error">
          <h1>Erreur {{error.code}}</h1>
          <h2>{{error.msg}}</h2>
        </div>

        <artwork ref="artwork" :prefix="`${plant.id}_${plant.title}`" :oeuvre="content.oeuvre" v-if="content"></artwork>
        <ui-footer ref="uiFooter"></ui-footer>

        <div class="single-plant__nav" v-if="nav">
          <navigation-button @click.native="tweenContent('prev')" :slug="nav.prev" direction="prev"></navigation-button>
          <navigation-button @click.native="tweenContent('next')" :slug="nav.next" direction="next"></navigation-button>
        </div>
      </div>

    </div>
</template>

<script>
import 'styles/components/single-plant.styl'
import * as PIXI from 'pixi.js'
import Detector from 'utils/Detector'
import Emitter from 'core/Emitter'
import SingleScene from './classes/SingleScene'

import Artwork from 'components/Artwork/index.vue'
import NavigationButton from 'components/UI/NavigationButton.vue'
import UiButton from 'components/UI/Button.vue'
import UiFooter from 'components/UI/Footer.vue'
import UiButtonToHome from 'components/UI/ButtonToHome.vue'

export default {
  name: 'single-plant',
  components: {
    Artwork,
    NavigationButton,
    UiFooter,
    UiButton,
    UiButtonToHome
  },
  data () {
    return {
      loading: false,
      plant: null,
      content: null,
      error: null,
      nav: null,
      shareInfos: null
    }
  },
  created () {
    this.fetchData()
  },
  mounted () {
    document.body.classList.remove('locked')
    this.bindAll()
  },
  beforeDestroy () {
    if (this.$parent.scene) {
      // this.$parent.scene.destroy()
      // this.$parent.scene = null

      this.removeListeners()

      Emitter.emit('SET_MENU_TRANSPARENT')
    }
  },

  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },

  methods: {
    fetchData () {
      // this.nav = this.plantData = this.content = null

      this.$parent.getSinglePlant(this.$route.params.slug).then(({plant, nav}) => {
        this.nav = nav
        this.plant = plant
        this.content = plant.content
        this.shareInfos = {
          url: window.location.protocol + '//' + window.location.host + window.location.pathname,
          title: this.content.title,
          text: `Désormais, je prends soin de moi avec ${this.content.title} ! #ExpoJardins`,
          // hashtags: 'ExpoJardins',
          via: 'GrandPalaisRmn'
        }
        this.$nextTick(() => {
          if (!this.isInit) {
            this.init()
          } else {
            this.$parent.scene.updateFlower(plant)
          }
        })
      }, ({error}) => {
        this.error = error
      })
    },

    addListeners () {
      Emitter.on('TICK', this.update)
      Emitter.on('RESIZE', this.resize)
    },

    removeListeners () {
      Emitter.removeListener('TICK', this.update)
      Emitter.removeListener('RESIZE', this.resize)
    },

    init () {
      console.log('Single Plant :: init')
      this.singleScrollContainer = this.$el.querySelector('.single-plant__scroll-container')
      this.singleContainer = this.$el.querySelector('.single-plant__container')
      this.container = this.$el.querySelector('.single-plant__canvas-container')

      this.ticker = PIXI.ticker.shared
      this.ticker.autoStart = false
      this.isInit = true
      this.addListeners()
      this.$parent.scene = new SingleScene({
        container: this.container,
        flowersData: this.plant
      })
      Emitter.emit('SOUND::PLAYINIT', {intro: false})
      this.enter()
    },

    bindAll () {
      ['update', 'resize']
          .forEach((fn) => (this[fn] = this[fn].bind(this)))
    },

    resize ({size}) {
      if (!this.$parent.scene) return

      this.singleContainer.style.minHeight = `${size.h * 0.8}px`

      let w = (size.BP === 'mobile') ? size.w : (this.container.offsetWidth * 1.1)
      let h = Math.max(size.h, (this.singleContainer.offsetHeight * 1.2))

      size.w = w
      size.hW = w / 2
      size.h = h
      size.hH = h / 2

      this.$parent.scene.resize(size)

      if (this.$parent.fakeScroll && this.$parent.scene.isReady) {
        this.resizeScroll()
      }
    },

    resizeScroll () {
      this.offsetHeight = this.singleScrollContainer.offsetHeight
      this.$parent.fakeScroll.style.height = `${this.offsetHeight}px`
    },

    update ({scrollVars, globalTime}) {
      this.$parent.scene.scroll(scrollVars)
      this.$parent.scene.update(globalTime)

      TweenMax.set(this.singleScrollContainer, {
        y: (-scrollVars.current)
      })
    },
    enter () {
      let subtile = this.$el.querySelector('.single-plant__subtitle')
      let title = this.$el.querySelector('.single-plant__title')
      let description = this.$el.querySelector('.single-plant__description')
      let sharingTxt = this.$el.querySelector('.sharing__text')
      let shargingBtns = this.$el.querySelectorAll('.sharing__btns .sharing__btn')
      let btnHome = this.$el.querySelector('.button-to-home')
      this.tlEnter = new TimelineMax()
      this.tlEnter.from([this.$refs.plantText, this.$refs.artwork.$el, this.$refs.uiFooter.$el], 1, {
        autoAlpha: 0
      }, '+=1')

      this.tlEnter.addLabel('start', '-=1')
      this.tlEnter.timeScale(1.5)
      this.tlEnter.staggerFrom(this.$refs.plantText.children, 1, {
        x: -30,
        autoAlpha: 0,
        ease: Cubic.easeOut,
        clearProps: 'all'
      }, 0.2, 'start')
      .from(sharingTxt, 1, {
        x: -30,
        autoAlpha: 0,
        ease: Cubic.easeOut
      }, 'start+=0.6')
      .staggerFrom(shargingBtns, 1, {
        x: -30,
        autoAlpha: 0,
        ease: Cubic.easeOut
      }, -0.05, 'start+=0.7')
      .from(btnHome, 0.8, {
        y: 30,
        autoAlpha: 0,
        ease: Back.easeOut
      }, 'start+=0.8')
      // tl.to(subtile,2,)
    },
    tweenContent (dir) {
      let title = this.$el.querySelector('.single-plant__title')
      let description = this.$el.querySelector('.single-plant__description')

      if (this.tlPrev) {
        this.tlPrev.kill()
        TweenMax.set([title, description], {clearProps: 'all'})
        this.tlPrev.clear()
      } else {
        this.tlPrev = new TimelineMax()
      }
      let x = dir === 'next' ? -30 : 30
      this.tlPrev.timeScale(1)
      this.tlPrev.staggerFrom([title, description], 1, {
        x: x,
        autoAlpha: 0,
        ease: Expo.easeOut
      }, 0.1)
    }
  }
}
</script>



/** WEBPACK FOOTER **
 ** index.vue?07ce0a8c
 **/